import { render } from "./OrderInvoiceSummary.vue?vue&type=template&id=b87fc426"
import script from "./OrderInvoiceSummary.vue?vue&type=script&lang=js"
export * from "./OrderInvoiceSummary.vue?vue&type=script&lang=js"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__